import * as selectors from './markets-selectors';

export const Markets = {
    ...selectors,
} as const;
